import React, { useContext, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import { ReactComponent as Logo } from '../../assets/logo.svg';
import SettingsIcon from '@material-ui/icons/Settings';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ClearIcon from '@material-ui/icons/Clear';
import CustomDialog from '../dialog';
import { Context } from '../../store';
import { Favorite } from '@material-ui/icons';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles({
  list: {
    width: '50vw',
    background: '#2B2B2B',
    height: '100%',
    color: 'white',
  },
});

export default function Sidebar({ props }) {
  const classes = useStyles();
  const { state, dispatch } = useContext(Context);
  const [open, setOpen] = useState(false);
  const Options = [
    {
      icon: (
        <img
          src={state.userImg}
          alt='userimage'
          style={{
            width: '24px',
            height: '24px',
            borderRadius: '50%',
          }}
        />
      ),
      name: 'Profile',
      func: () => {
        props.history.push(`/profile/${state.token}`);
      },
    },
    {
      icon: <SettingsIcon />,
      name: 'Settings',
      func: () => {
        props.history.push('/settings');
      },
    },
    {
      icon: <ArrowForwardIosIcon />,
      name: 'Logout',
      func: () => {
        setOpen(true);
      },
    },
  ];

  const [defstate, setdefState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setdefState({ ...defstate, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      style={{
        background: '#2B2B2B',
      }}
      className={clsx(classes.list)}
      role='presentation'
      onKeyDown={toggleDrawer(anchor, false)}>
      <ClearIcon
        onClick={toggleDrawer('left', false)}
        fontSize='large'
        style={{
          color: 'white',
        }}
      />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '10px 0',
        }}
        onClick={() => props.history.push('/')}>
        <Logo />
      </div>
      <List>
        <Accordion
          style={{
            background: '#4A4A4A',
            marginBottom: '1px',
            color: 'white',
          }}>
          <AccordionSummary
            aria-controls='panel1a-content'
            id='panel1a-header'
            expandIcon={
              <ExpandMoreIcon
                style={{
                  color: 'white',
                }}
              />
            }>
            Channel
          </AccordionSummary>
          <AccordionDetails
            style={{
              background: '#333',
              marginBottom: '1px',
              color: 'white',
            }}
            onClick={() => {
              props.history.push('/main');
            }}>
            # Cai
          </AccordionDetails>
          <AccordionDetails
            style={{
              background: '#333',
              marginBottom: '1px',
              color: 'white',
            }}
            onClick={() => {
              props.history.push('/global');
            }}>
            # Global
          </AccordionDetails>
        </Accordion>
        {state.logged ? (
          Options.map((i) => {
            return (
              <ListItem
                button
                key={i.name}
                onClick={i.func}
                style={{
                  background: '#4A4A4A',
                  marginBottom: '1px',
                }}>
                <ListItemIcon
                  style={{
                    color: 'white',
                  }}>
                  {i.icon}
                </ListItemIcon>
                <ListItemText primary={i.name} />
              </ListItem>
            );
          })
        ) : (
          <ListItem
            button
            onClick={() => {
              props.history.push('/register');
            }}
            style={{
              background: '#4A4A4A',
              marginBottom: '1px',
            }}>
            <ListItemIcon
              style={{
                color: 'white',
              }}>
              <ArrowForwardIosIcon />
            </ListItemIcon>
            <ListItemText primary={'Sign In'} />
          </ListItem>
        )}
      </List>
      <div
        style={{
          position: 'absolute',
          bottom: '0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          margin: '10px 0',
        }}>
        <div>Made by Bdbose</div>
        <Favorite />
      </div>
    </div>
  );

  return (
    <div>
      <React.Fragment>
        <Button
          onClick={toggleDrawer('left', true)}
          style={{
            color: 'white',
          }}>
          <MenuIcon fontSize='large' />
        </Button>
        <Drawer
          anchor={'left'}
          open={defstate['left']}
          onClose={toggleDrawer('left', false)}>
          {list('left')}
        </Drawer>
      </React.Fragment>
      <CustomDialog
        open={open}
        onSubmit={() => {
          dispatch({ type: 'USER_LOGOUT' });
          props.history.push('/login');
        }}
        handleClose={() => {
          setOpen(false);
        }}
        MainText={'Are You Sure?'}
        AgreeText='Logout'
        CloseText='Cancel'
      />
    </div>
  );
}
